// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgi_a bih_wj bih_ss bih_xl"};